import { ZoomInIcon } from '@radix-ui/react-icons'
import { useKestrel } from 'features/kestrelViewer'
import React, { FC } from 'react'
import styled from 'styled-components'

const StyledZoomIcon = styled(ZoomInIcon)`
  color: lightgray;
  &:hover {
    color: white;
  }
`

export const ZoomToAnnotationButton: FC<{
  annotationId: string
}> = ({ annotationId }) => {
  const { sendKVCommand, setSelectedMarkup } = useKestrel()

  const zoomToAnnotation = (e: React.MouseEvent) => {
    e.stopPropagation()
    setSelectedMarkup(undefined)
    if (sendKVCommand) {
      sendKVCommand({
        command: 'zoomToAnnotation',
        annotationId: annotationId,
      })
    }
  }

  return (
    <div style={{ cursor: 'pointer' }} onClick={(e) => zoomToAnnotation(e)}>
      <StyledZoomIcon width={22} height={22} />
    </div>
  )
}
